/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { Input } from 'tdesign-react';

import { IRelationshipValue } from '..';
import styles from './index.module.less';

interface IProps {
  onChange: (value: IRelationshipValue) => void;
  value: IRelationshipValue;
  disabled: boolean;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;
  const [val, setVal] = useState<IRelationshipValue>({ name: '', relation: '' });

  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange1 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      name: val,
    }));
    onChange({ ...value, name: val });
  }, [value, onChange]);

  const handleChange2 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      relation: val,
    }));
    onChange({ ...value, relation: val });
  }, [value, onChange]);

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <Input value={val.name} disabled={disabled} onChange={handleChange1} />
      </div>
      是你的
      <div className={styles.wrapper}>
        <Input value={val.relation} disabled={disabled} onChange={handleChange2} />
      </div>
    </div>
  );
};

export default ItemComp;
